const sanitizeLang = (language) => {
  if (!language) return "en";
  return language.split("-")[0].toLowerCase() || "en";
};

export const getLocalizedNewsTitle = (item = {}, language = "en") => {
  return getLocalizedField(item, "title", language);
};

/**
 * Generic field localizer.
 * Looks for `{field}_{lang}`, falls back to `{field}_{en}`, then `{field}`.
 */
export const getLocalizedField = (item = {}, field = "title", language = "en") => {
  if (!item || typeof item !== "object") {
    return typeof item === "string" ? item : "";
  }

  const lang = sanitizeLang(language);
  const candidates = [
    `${field}_${lang}`,
    lang !== "en" ? `${field}_en` : null,
    field,
  ].filter(Boolean);

  for (const key of candidates) {
    const value = item[key];
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed && trimmed !== "N/A") return trimmed;
    }
  }
  return item[field] || "";
};

export default getLocalizedNewsTitle;
